import { useUserStore } from '@/stores/user'

import { SegmentedProgressBar } from './SegmentedProgressBar'
import { SelectedData } from './volume-quota-modal'

interface VolumeQuotaSegmentedBarProps {
  summarizedData: SelectedData
}

export function VolumeQuotaSegmentedBar({ summarizedData }: VolumeQuotaSegmentedBarProps) {
  const userStore = useUserStore()
  const totalQuotaInGB = userStore.partVolume?.quota_gb || 0

  const countQuota = (quotasInGB?: Array<number>) => {
    if (!quotasInGB) return 0
    return quotasInGB.reduce((acc, vol) => {
      return acc + vol
    }, 0)
  }

  const snapshotTotalQuota = countQuota(
    summarizedData.selectedData.filter((i) => i.volume.type === 2).map((i) => i.selectedQuotaInGB),
  )
  const cloudTotalQuota = countQuota(
    summarizedData.selectedData.filter((i) => i.volume.type !== 2).map((i) => i.selectedQuotaInGB),
  )

  const snapshotQuota = totalQuotaInGB > 0 ? snapshotTotalQuota / totalQuotaInGB : 0
  const snapshotAndVolumeQuota =
    totalQuotaInGB > 0 ? (snapshotTotalQuota + cloudTotalQuota) / totalQuotaInGB : 0

  return <SegmentedProgressBar value={snapshotQuota} secondValue={snapshotAndVolumeQuota} />
}
